// extracted by mini-css-extract-plugin
export default {"wrapper":"UB-z","viewport":"VB-z","container":"WB-z","slide":"XB-z"};